import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAdmin } from './context/AdminContext';
import AdminLayout from './AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import HomeManager from './pages/HomeManager';
import AboutManager from './pages/AboutManager';
import ServicesManager from './pages/ServicesManager';
import GalleryManager from './pages/GalleryManager';
import TeamManager from './pages/TeamManager';
import TestimonialsManager from './pages/TestimonialsManager';
import PartnersManager from './pages/PartnersManager';
import JourneyManager from './pages/JourneyManager';

const AdminApp = () => {
  const { isAuthenticated } = useAdmin();

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/home" element={<HomeManager />} />
        <Route path="/about" element={<AboutManager />} />
        <Route path="/services" element={<ServicesManager />} />
        <Route path="/gallery" element={<GalleryManager />} />
        <Route path="/team" element={<TeamManager />} />
        <Route path="/testimonials" element={<TestimonialsManager />} />
        <Route path="/partners" element={<PartnersManager />} />
        <Route path="*" element={<Navigate to="/admin" />} />
        <Route path="/journey" element={<JourneyManager />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminApp;